import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTable-root': {
      border: 'solid 1px rgba(109, 114, 120, 0.18)',
      borderRadius: 4,
    },
    '& .MuiTableRow-head th:first-child': {
      borderTopLeftRadius: 4,
    },
    '& .MuiTableRow-head th:last-child': {
      borderTopRightRadius: 4,
      width: 145,
    },
  },
  actionButton: {
    display: 'flex',
    justifyContent: 'end',
  },
  expandBtn: {
    border: `1px solid #2b3990`,
    padding: theme.spacing(2),
    margin: 0,
    background: 'white',
    color:'#2b3990',
    '&:hover':{
      background:'#2b3990',
      color: '#fff'
    }
  },
  props: {
    padding: theme.spacing(2, 3),
    boxSizing: 'border-box',
  },
  tickIcon: {
    color: '#43A047',
    fontSize: 17,
  },
  tickItem: {
    marginBottom: theme.spacing(1),
  },
  propsTitle: {
    color: '#2b3940',
    fontWeight: 'bold',
    fontSize: 12,
    marginBottom: theme.spacing(1.5),
  },
  tickText: {
    fontSize: 12,
    fontWeight: 'normal',
    marginInlineStart: theme.spacing(1),
    color: '#2b3940',
  },
  info: {
    borderRadius: 4,
    padding: theme.spacing(1.5),
  },
  detail: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
  },
  detailTitle: {
    fontSize: 12,
    color: '#546e7a',
    marginBottom: theme.spacing(1),
  },
  detailValue: {
    fontSize: 14,
    color: '#003a52',
    marginBottom: theme.spacing(0.5),
  },


  contentLine: {
    height: '20px',
    width: '100%',
    marginBottom: '16px',
    //borderRadius: '8px',
  },
  contentCheckbox: {
    height: '20px',
    width: '25px',
    marginBottom: '16px',
    //borderRadius: '8px',
    margin: '0 8px'
  },

  shimmerBG: {
    minHeight: '20px',
    //borderRadius: '8px',
    animation: '$shimmer 2s infinite',
    'animation-fill-mode': 'forwards',
    'animation-timing-function': 'linear',
    background: 'linear-gradient(to right, #F6F6F6 8%, #F0F0F0 18%, #F6F6F6 33%)',
    'background-size': '1200px 100%',
  },
  '@keyframes  shimmer': {
    '0%': {
      'background-position': '-100% 0',
    },
    '100%': {
      'background-position': '100% 0',
    },
  },
  '@keyframes  shimmer': {
    '0%': {
      'background-position': '-1200px 0',
    },
    '100%': {
      'background-position': '1200px 0',
    },
  },

}));
